import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=17190692&scoped=true"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"
import style0 from "./footers.vue?vue&type=style&index=0&id=17190692&prod&scoped=true&lang=css"
import style1 from "./footers.vue?vue&type=style&index=1&id=17190692&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17190692",
  null
  
)

export default component.exports